var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStats = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15 9.75h4.75a.5.5 0 0 1 .5.5v9.5a.5.5 0 0 1-.5.5H15m0-10.5v10.5m0-10.5v-5.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V12m6 8.25H9m0 0H4.25a.5.5 0 0 1-.5-.5V12.5a.5.5 0 0 1 .5-.5H9m0 8.25V12",
  stroke: "#fff",
  strokeWidth: 1.5
})));
export default SvgStats;